import React from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { GetFrameworkCategories } from '../../queries/frameworks'
import { Query } from 'react-apollo'
import DataLoader from '../../app/DataLoader'
import HighLevelCategories from './HighLevelCategories'
import LowLevelCategories from './LowLevelCategories'
import { signout } from '../../redux/actions/userActions';
import frameworkMapping from '../../utils/frameworkMapping'
import {loader} from '../Loader'
class ControlContent extends React.Component {
  constructor() {
    super();
    this.state = { someKey: 'someValue' };
  }

  render() {
    const { navigationStyle } = styles
    const highLevelCategory = this.props.match.params.control_name
    let sortedCategories = []
    
    let frameworkID = Object.entries(frameworkMapping).find(framework => {
      return framework[1].path.includes(this.props.match.params.frameworkName)
    })
    return(
      <DataLoader>
        <div className="control-container">
        <Query
            query={GetFrameworkCategories()}
            fetchPolicy={'network-only'}
            variables={{ frameworkID: Number(frameworkID[0]) }}
            onError={(e) => {
              if (e.networkError) {
                if (e.networkError['statusCode'] === 401) {
                  this.signoutUser()
                }
              } else {
                console.log(e.message)
                this.signoutUser()
              }
            }}
            onCompleted={(data) => {
            }}>
            {({ loading, error, data }) => {
              if (!loading && this.props.dataLoaded) {
                if (data && data.frameworkCategories) {
                  sortedCategories = data.frameworkCategories.categories.slice(0)

                  if (data.frameworkCategories.flat === true || highLevelCategory) {
                    return (<LowLevelCategories
                      loaded={!loading}
                      loading={loading}
                      navigationStyle={navigationStyle}
                      categories={sortedCategories}
                      flat={data.frameworkCategories.flat}
                      totalControls={
                        data.frameworkCategories.numberOfControls -
                        data.frameworkCategories.numberOfNotApplicableControls
                      }
                      compliantControlsTotal={0}
                      frameworkName={this.props.match.params.frameworkName.toUpperCase()}
                      headingDescription={this.props.description}
                      highLevelCategory={highLevelCategory}
                      urlFrameworkName={data.frameworkCategories.framework}
                      frameworkId={this.props.frameworkId}
                      parse={this.props.parse}
                    />)
                  } else {
                    try {
                      sortedCategories.sort((a, b) => {
                        if (a.highLevelOrder && b.highLevelOrder) {
                          return Number(a.highLevelOrder) - Number(b.highLevelOrder)
                        } else {
                          return 0
                        }
                      })
                    } catch (err) {
                    }

                    return (<HighLevelCategories
                      categories={sortedCategories}
                      frameworkName={this.props.match.params.frameworkName.toUpperCase()}
                      headingDescription="Choose a high level category to edit its controls' help texts."
                      urlFrameworkName={data.frameworkCategories.framework}
                    />)
                  }
                }
              } else if (error) {
                console.log(`ERROR > ${error.message}`)
                return null
              } else {
                return loader
              }
            }}
          </Query>
        </div>
      </DataLoader>
    )
  }
}

const styles = {
  navigationStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer'
  }
}

function mapStateToProps (state) {
  return {
    user: state.auth.user,
    summary: state.controlsData.summary,
    dataLoaded: !state.controlsData.loading,
    sidebar: state.sidebar
  }
}
export default connect(mapStateToProps, { signout })(withRouter(ControlContent));



// WEBPACK FOOTER //
// ./src/components/content_management/ControlContent.js